const quotations = [
  {
    guest_client_quotation_id: 1,
    guest_client_quotation_ref: '#1234',
    client_names: 'Robert Muthumbi',
    status: 'PENDING:IN-PROGRESS',
    created_date: '2025-09-01',
    category: 'Motor Private',
    avatar: '../../assets/images/agent.png',
    gender: 'Male',
    city: 'Nairobi',
    registration_date: '12/01/2021',
    address: 'Nairobi',
  },
  {
    guest_client_quotation_id: 2,
    guest_client_quotation_ref: '#5678',
    client_names: 'Jane Doe',
    status: 'PENDING:PURCHASE',
    created_date: '2025-08-30',
    category: 'Home Insurance',
    avatar: '../../assets/images/avatar2.png',
    gender: 'Female',
    city: 'Mombasa',
    registration_date: '15/03/2022',
    address: 'Mombasa',
  },
];

const documents = [
  { title: 'Document 1', description: 'Sample description' },
  { title: 'Document 2', description: 'Sample description' },
];

export { quotations, documents };